import { render, staticRenderFns } from "./SntNumberField.vue?vue&type=template&id=49f543d0&scoped=true&"
import script from "./SntNumberField.vue?vue&type=script&lang=js&"
export * from "./SntNumberField.vue?vue&type=script&lang=js&"
import style0 from "./SntNumberField.vue?vue&type=style&index=0&id=49f543d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f543d0",
  null
  
)

export default component.exports